import React from 'react';
import ignoreIcon_1 from '../assets/images/1_Intro/intro_pivotal_ignore_1c.png';
import ignoreIcon_2 from '../assets/images/1_Intro/intro_pivotal_ignore_2c.png';
import ignoreIcon_3 from '../assets/images/1_Intro/intro_pivotal_ignore_3c.png';

const SurvivalSection = () => {
    return (
        <div className="col-md-12 survival-section">
            <h4>We risk the survival of the system itself&mdash;and New York with it.</h4>
            <div className="row">
                <div className="col-md-4">
                    <img src={ignoreIcon_1} alt="" aria-hidden="true" className="circ-img" />
                    <p>Without more aggressive intervention, the deteriorating structural beams holding up the 110-year-old Train Shed at Grand Central Terminal&mdash;that supports Park Avenue and provides a roof for trains&mdash;is at risk of failure, <strong>suspending Metro-North service into Manhattan</strong>.</p>
                </div>
                <div className="col-md-4">
                    <img src={ignoreIcon_2} alt="" aria-hidden="true" className="circ-img" />
                    <p style={{marginRight: "10px", marginLeft: "10px"}}>In 20 years, more than 75% of the New York City subway major power substation components will be more than half a century old, risking <strong>extended power outages across the system and potentially shutting down multiple lines</strong>.</p>
                </div>
                <div className="col-md-4">
                    <img src={ignoreIcon_3} alt="" aria-hidden="true" className="circ-img" />
                    <p>As climate change accelerates and extreme weather events become more common,<strong> we risk asset failures and system shutdowns without targeted climate resilience protections</strong>.</p>
                </div>
            </div>
            <p>
                <a className="plus-sign red" href="history">We've been here before. Revisit our history.</a>
            </p>
        </div>
    );
};

export default SurvivalSection;